import { FC, useContext, useCallback } from "react";
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  Text,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { AppContext } from "../../../../AppContext";
import { NavigationMenu } from "../../components/NavigationMenu";
import { Logo, AvatarLogo } from "../../components/MenuIcons";
import { useLoginOut } from "../../../appLayout/hooks";
import { useCurrentUser } from "../../hooks";
import { Link } from 'react-router-dom';

export const Sidebar: FC = () => {
  const { setSidebarIsOpen } = useContext(AppContext);
  const { loginOut } = useLoginOut();
  const { userName } = useCurrentUser();

  const handleOpenSidebar = useCallback(() => {
    setSidebarIsOpen(true);
  }, []);

  return (
    <>
      <Box borderBottomWidth={"1px"} padding="0 20px" backgroundColor="#121419">
        <Flex
          flexDirection={"row"}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Box>
            <Flex
              flexDirection={"row"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Link to="/">
                <Box w="95px" h="60px">
                  <Logo w="100%" h="100%" />
                </Box>
              </Link>
              <Box marginRight={"30px"} marginLeft={"18px"}>
                <Text fontSize="md" color={"#fafafa"}>
                  Москва
                </Text>
              </Box>
              <Menu>
                <Flex justify="space-between">
                  <Box h="60px">
                    <MenuButton
                      as={Button}
                      leftIcon={<HamburgerIcon fontSize={"18px"} />}
                      onClick={handleOpenSidebar}
                      padding="0 43px"
                      h="100%"
                      borderRadius={"0"}
                      colorScheme="teal"
                      backgroundColor={"#282C35"}
                      color="#fafafa"
                    >
                      Меню
                    </MenuButton>
                  </Box>
                </Flex>
              </Menu>
            </Flex>
          </Box>
          <Box>
            <Flex
              flexDirection={"row"}
              alignItems="center"
              justifyContent={"space-between"}
              gap="12px"
            >
              <AvatarLogo fontSize="24px" />
              <Text fontSize="md" color={"#fafafa"}>
                {userName}
              </Text>
              <Button variant="link" size="sm" onClick={loginOut}>
                Выход
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Box>
      <NavigationMenu />
    </>
  );
};
